var $ = window.$;


var selectors = {
	BUTTON_PAYMENT: '.dkt-checkout-primary-button',

}
var actors = {
	CANCELLATION_SERVICE:'rest/model/atg/commerce/order/purchase/CancelOrderActor/cancelOrder'
};

var settings = {
	MAIN_CONTAINER: 'main-container',
  ORDER_CANCELLATION: 'order-cancellation',
  INVOICE_PARTNER: 'pop-partner-modal',
	PRODUCT_ITEM_CANCELLED: 'order-product-detail--item-cancelled',
  ORDER_DETAIL_STEPS: 'order-detail-steps',
  MODAL_MP: 'pop-up-modal-return-mp'
};



module.exports = {

	init: function() {

		this.putCancelledItemsDown();
		this.showPopOver();
		this.initSliderProducts();
    this.cancelOrder();
    this.invoicePartner();
    this.modalMP();

    const printOrderButton = document.querySelectorAll('.js-order-print-btn');
    if (printOrderButton) {
      printOrderButton.forEach((printButton) => {
        printButton.addEventListener('click', () => {
          const savedTitle = document.title;
            document.title = document.title.removeDiacritics();
            window.print();
            document.title = savedTitle;
        });
      });
    }
	},

	putCancelledItemsDown: function() {
		if ($('.' + settings.PRODUCT_ITEM_CANCELLED).length != 0 && !$('.' + settings.PRODUCT_ITEM_CANCELLED).hasClass("ismarketplace")) {
			$('.' + settings.PRODUCT_ITEM_CANCELLED).detach().insertBefore($('.order-footer-tab'));
		}
	},

	showPopOver: function() {
		if($('#' + settings.ORDER_CANCELLATION).data('popover') === true) {
			$('#' + settings.ORDER_CANCELLATION).popover('show');
		}

		var btnOrderDisabled = '[data-js="order-disabled"]';
		$('#' + settings.MAIN_CONTAINER).on('mouseenter', btnOrderDisabled, function(){
			$(this).popover('show');
		}).on('mouseleave', btnOrderDisabled, function(){
			$(this).popover('hide');
		});

		$('#' + settings.MAIN_CONTAINER).on('click', btnOrderDisabled, function(e){
			e.preventDefault();
		});
	},

	initSliderProducts: function() {
		$('#delivery-details').on('shown.bs.collapse', function(e) {
			decathlon.tools.slickReinitSlider('.products-slider-container', '.products-slider', '', window.productListSlickSettings);
		});
	},

	cancelOrder: function() {
		var _self = this;
		const modal = cube.$id('modal-cancel-order');

		$('#' + settings.MAIN_CONTAINER).on('click', '#' + settings.ORDER_CANCELLATION, function(){
			modal.checked = true;
			$('#' + settings.ORDER_CANCELLATION).popover('hide');
		});

		$('#' + settings.MAIN_CONTAINER).on('click', '#confirmCancellation', function(e){
			decathlon.tools.displayLoader(true, true);

			getAjaxHandler()
			.withCaller($(this))
			.withUrl(actors.CANCELLATION_SERVICE)
			.withParameter('orderIdToCancel', $(this)[0].dataset.orderId)
			.withSuccess(_self.cancelOrderSuccess)
			.call();
		});

		$('#' + settings.MAIN_CONTAINER).on('click', '#cancelCancellation', function (e) {
			e.preventDefault();

			modal.checked = false;
		});
	},

	cancelOrderSuccess:function() {

		// hideCancellationPopin and popover
		cube.$id('modal-cancel-order').checked = false;
		$('#' + settings.ORDER_CANCELLATION).popover('hide');

		//showInformationMessage
		$('#order-cancelled-info').removeClass('hidden');

		//grayedTimeline
		$('.' + settings.ORDER_DETAIL_STEPS + '--order-only').addClass(settings.ORDER_DETAIL_STEPS + '--cancellation');
		$('.' + settings.ORDER_DETAIL_STEPS + '--order-only').parent().find('.block-container__title-container').addClass('hidden');

		// hideActionButtons
		$('.order-cta-container').addClass('hidden');


		decathlon.tools.displayLoader(false, false);
  },

  invoicePartner: function() {
		$('#' + settings.MAIN_CONTAINER).on('click', '#' + settings.INVOICE_PARTNER, function(){
      cube.$id('modal-seller-invoice').checked = true;
		});
  },

  modalMP: function() {
    $('#' + settings.MAIN_CONTAINER).on('click', '#' + settings.MODAL_MP, function(){
      cube.$id('modal-mp-return').checked = true;
		});
  }
}



// WEBPACK FOOTER //
// ./src/modules-es5/account/order/order.js